/* src/app/views/template/components/templates/print/print-card-templates/print-card-template-list/print-card-template-list.component.scss */
/*# sourceMappingURL=print-card-template-list.component.css.map */
